export default "__VITE_ASSET__CAik9$ME__"